import { render } from "./Browse.vue?vue&type=template&id=8c6a91ea&scoped=true"
import script from "./Browse.vue?vue&type=script&lang=js"
export * from "./Browse.vue?vue&type=script&lang=js"

import "./Browse.vue?vue&type=style&index=0&id=8c6a91ea&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc/v1/v1/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c6a91ea"]])

export default __exports__